// 获取出生年份列表
export function getBothYearList(before, next) {
  // type:Number
  // 传入需要获取的年份数（before为往前多少年，next为往后多少年）
  let y = new Date().getFullYear()
  let arr = []
  for (let i = before; i > 0; i--) {
    const str = (y - i).toString();
    arr.push(str);
  }
  for (let i = 1; i <= next; i++) {
    const str = (y + i).toString();
    arr.push(str);
  }
  return arr
}
